import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.424 2.424l-.848-.848L9 8.152 2.424 1.576l-.848.848L8.152 9l-6.576 6.576.848.848L9 9.848l6.576 6.576.848-.848L9.848 9z" />
  </svg>
);

export default SvgComponent;
